import { render, staticRenderFns } from "./DataTeachers.vue?vue&type=template&id=6b5a0be0"
import script from "./DataTeachers.vue?vue&type=script&lang=js"
export * from "./DataTeachers.vue?vue&type=script&lang=js"
import style0 from "./DataTeachers.vue?vue&type=style&index=0&id=6b5a0be0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports